import { stats } from "@/mocks/stats";

export default function StatsSection() {
  return (
    <section className="py-12 md:py-20 bg-gradient-to-br from-primary-900 to-primary-800 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/3"></div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-3">
            Numbers That Speak for Us
          </h2>
          <p className="text-primary-200 text-base md:text-lg max-w-2xl mx-auto">
            Years of dedication to helping Indian families make smarter insurance and investment decisions.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className="bg-white/10 backdrop-blur-sm rounded-xl p-5 md:p-6 text-center border border-white/10 hover:bg-white/15 transition-all"
            >
              <div className="w-10 h-10 rounded-lg bg-white/15 flex items-center justify-center mx-auto mb-3">
                <i className={`${stat.icon} text-white text-lg`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-extrabold text-white mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-primary-200">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}